import { render, staticRenderFns } from "./Front.vue?vue&type=template&id=50b84435&scoped=true"
import script from "./Front.vue?vue&type=script&lang=js"
export * from "./Front.vue?vue&type=script&lang=js"
import style0 from "./Front.vue?vue&type=style&index=0&id=50b84435&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b84435",
  null
  
)

export default component.exports